import { app } from '@/bootloader';

import IncrediUI from 'incredi-ui';

app.use(IncrediUI);
